import {
  Directions,
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '@cp/components/TooltipV2/TooltipV2';
import InfoSolidSmallIcon from '@cp/src/assets/icons/InfoSolidSmallIcon';
import { Typography } from '@navi/web-ui/lib/primitives';

const CaseCountTooltip = () => (
  <Tooltip placement={Directions.TOP} hideStrategy="referenceHidden">
    <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
      <InfoSolidSmallIcon fill={'var(--navi-color-gray-c3)'} />
    </TooltipTrigger>
    <TooltipContent className={'tooltipWrapper px-2 py-1 !max-w-[305px]'}>
      <Typography variant="p4" color="var(--navi-color-gray-bg-primary)">
        {'Run the query to get the number of cases.'}
      </Typography>
      <Typography variant="p4" color="var(--navi-color-gray-bg-primary)">
        {
          '(Output value reflects eligible cases as of today. Count may change on actual allocation dates due to changes in eligible cases)'
        }
      </Typography>
    </TooltipContent>
  </Tooltip>
);

export default CaseCountTooltip;
